import { ComboField } from '@components/Fields/ComboField';
import { CompetenciaField } from '@components/Fields/CompetenciaField';
import { FixedFilterPanel } from '@components/FixedFilterPanel';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { IFilter } from '@hooks/useFilter';
import { MenuItem } from '@material-ui/core';
import { IComboRemetenteWhatsapp } from '@model/RemetenteWhatsapp';
import { INovosInadimplentesFilter } from '@services/RelatorioService';
import React from 'react';

export type NovosInadimplentesFilterProps = {
    filter: IFilter<INovosInadimplentesFilter>
    isLoading: boolean
    remetenteWhatsappCombo: IComboRemetenteWhatsapp
}

export function NovosInadimplentesFilter ({ filter, isLoading, remetenteWhatsappCombo }: NovosInadimplentesFilterProps) {
    const handleReset = React.useCallback(() => {
        filter.resetFilter();
    }, [filter]);

    return (
        <FixedFilterPanel
            onSearch={filter.handleFilterRequest}
            onClear={handleReset}
            disabled={isLoading}
        >
            <HorizontalGrid spacing={1}>
                <GridItem xs={2}>
                    <CompetenciaField
                        field={filter.fields.competencia}
                        label="Competência Ref."
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        required
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={4}>
                    <ComboField
                        field={filter.fields.remetenteWhatsapp}
                        label="Remetente"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value="">Todos</MenuItem>
                        {remetenteWhatsappCombo.createOptionsWithNumero()}
                    </ComboField>
                </GridItem>
           </HorizontalGrid>
        </FixedFilterPanel>
    )
}